var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag-tradein-cart-item-status"},[_c('Tag',{attrs:{"text":_vm.$t(`trade_in_carts.status.${_vm.status}.title`),"color":_vm.statusColor[_vm.status] || 'grey'}}),_c('ToolTip',{attrs:{"infos":_vm.$t(`trade_in_carts.status.${_vm.status}.description`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }